import Vue from 'vue'
import { getUrl } from './get-url.js'
import axios from "axios";

export default {
    get: function () {
        console.log(Vue.http);
        return Vue.http.get(getUrl('/categories'))
    },
    getByCode: function (code) {
        if (!code) {
            console.warn('Categories.getByCode code is not provided')
            return Promise.reject()
        }
        return Vue.http.get(getUrl('/categories/' + code))
    },
    getVideos: function (id) {
        return Vue.http.get(getUrl('/categories/' + id + '/videos'))
    },
    getQuestions: function(id) {
        return Vue.http.get(getUrl('/categories/' + id + '/questions'));
    },
    getResponses: function (user_id) {
        return Vue.http.post(getUrl('/categories/formation'), user_id);
    },
    checkAnswers: function(questionnaire) {
        let answers = [].concat.apply([], questionnaire.map(q => q.answers))
            .map(a => { return { id: a.id, checked: a.checked }; });
        return Vue.http.post(getUrl('/categories/answers'), answers);
    },
    sendAnswer: function(result) {
        return Vue.http.post(getUrl('/categories/result'), result);
    }
}



// WEBPACK FOOTER //
// ./src/services/categories.js